// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__EgFv2","wrapper":"style__wrapper__Im7MM"};